import { nanoid } from "nanoid";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { startForgotPasswordProcess } from "../../app/actions/authActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { formatToTwoDigits } from "../../app/helpers/formatToTwoDigits";
import useFormGeneric from "../../app/hooks/useFormGeneric";
import validate from "../../app/validations/ForgotPasswordFormValidationRules";

const initialData = {
  email: ""
};

const ForgotPassword = () => {
  debugLogPages('---> ForgotPassword');
  
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { values, errors, handleChange, handleSubmit } = useFormGeneric(loginCallback, validate, initialData);

  function loginCallback() {
    
    const id_generated = nanoid();

    const dateNow = new Date();

    const yearFormat = dateNow.getFullYear();
    const monthFormat = formatToTwoDigits(dateNow.getMonth() + 1);
    const dayFormat = formatToTwoDigits(dateNow.getDate());
    const hoursFormat = formatToTwoDigits(dateNow.getHours());
    const minutesFormat = formatToTwoDigits(dateNow.getMinutes());
    const secondsFormat = formatToTwoDigits(dateNow.getSeconds());

    const varDateFormat = yearFormat + monthFormat + dayFormat + hoursFormat + minutesFormat + secondsFormat;

    dispatch(startForgotPasswordProcess(values.email, id_generated + varDateFormat));

  }

  return (
    <section className="gradient-custom-sky">
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-12 col-md-8 col-lg-6 col-xl-5 login-card">
            <div className="card bg-color2 borderR2 text-white">
              <form onSubmit={handleSubmit} noValidate>
                <div className="card-body p-5 text-center">
                  <div className="mb-md-5 mt-md-4 pb-5">
                    <h2 className="fw-bold mb-2 text-uppercase">{t("forgot-password.screen.title")}</h2>
                    <p className="text-white-50 mb-5">{t("forgot-password.screen.message")}</p>

                    <div className="form-outline form-white mb-4">
                      <label className="form-label" htmlFor="typeEmailX">
                        {t("forgot-password.screen.email")}
                      </label>
                      <input
                        type="email"
                        id="typeEmailX"
                        className={`form-control form-control-lg ${errors.email && "is-invalid"}`}
                        autoComplete="off"
                        name="email"
                        onChange={handleChange}
                        value={values.email || ""}
                        required
                      />
                      {errors.email && <pre><p className="text-error">{errors.email}</p></pre>}
                    </div>
                    <p className="small mb-5 pb-lg-2">
                      <Link to="/login" className="text-white-50 fw-bold">{t("forgot-password.screen.login")}</Link>
                    </p>

                    <button className="btn btn-outline-light btn-lg px-5" type="submit">
                      {t("forgot-password.screen.button")}
                    </button>
                  </div>
                  <div>
                    <p className="mb-0">
                      {t("forgot-password.screen.do-not-have-an-account-yet")}
                      <Link to="/sign-up" className="text-white-50 fw-bold">{t("forgot-password.screen.register.link")}</Link>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
